import { render } from "./PermissionView.vue?vue&type=template&id=199e174d&scoped=true"
import script from "./PermissionView.vue?vue&type=script&lang=js"
export * from "./PermissionView.vue?vue&type=script&lang=js"

import "./PermissionView.vue?vue&type=style&index=0&id=199e174d&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199e174d"]])

export default __exports__